/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: oujinfa oujinfa@100efly.com
 * @Date: 2024-01-22 10:20:01
 * @LastEditTime: 2024-04-29 13:18:53
 * @Descripttion: file content
 */
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import style from './index.module.scss'

import logoIcon from '@/static/bingo/image/logo.png'
import logoLoginIcon from '@/static/bingo/image/logo_login.png'
import teaRoute from '@/routes/tea'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { CommStateType } from '@/redux/reducer/commReducer'
import { UserStateType } from '@/redux/reducer/userReducer'
import { TeaInfoType } from '@/types/tea'
import { DownOutlined } from '@ant-design/icons'
import { URL_COMM } from '@/project.config'
import { Dropdown, message } from 'antd'
import { commAction, homeworkAction, userAction } from '@/redux/action'
import { persistor } from '@/redux'
import Alert from '../Alert'
import { SHOW_LOGO } from '@/globalConfig'
import api from '@/api'

export default function Header() {
	const token = useSelector<CommStateType, string>(state => state.comm.token, shallowEqual)
	const teaInfo = useSelector<UserStateType, { tea: TeaInfoType }>(state => ({ tea: state.user.tea }), shallowEqual)
	const [active, setActive] = useState('home')
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const linkTo = (path: string) => {
		return () => {
			navigate('/tea/' + path, { replace: true })
			setActive(path)
		}
	}

	const location = useLocation()

	useEffect(() => {
		teaRoute.forEach(item => {
			if (location.pathname.split('/').indexOf(item.path) !== -1) {
				setActive(item.path === active ? active : item.path)
			}
		})
	}, [location.pathname])

	const loginOut = () => {
		Alert.show({
			type: 'toast',
			subTitle: '确定退出登录吗？',
			cancelText: '取消',
			confirmText: '确认',
			confirmCallback: async () => {
				try {
					await api.logout()
					dispatch({ type: commAction.SET_TOKEN, payload: '' })
					persistor.purge()
					dispatch({ type: commAction.RESET_COMM_STORE })
					dispatch({ type: homeworkAction.RESET_HOMEWORK_STORE })
					dispatch({ type: userAction.RESET_USER_STORE })

					window.location.replace('/login')
				} catch (error) {
					dispatch({ type: commAction.SET_TOKEN, payload: '' })
					persistor.purge()
					dispatch({ type: commAction.RESET_COMM_STORE })
					dispatch({ type: homeworkAction.RESET_HOMEWORK_STORE })
					dispatch({ type: userAction.RESET_USER_STORE })
					// message.error('退出登陆失败')
				}

			}
		})
	}

	const goProfile = () => {
		navigate('/profile')
	}

	return (
		<div className={style.header}>
			<div className={style.content}>
				<div className={style.contentLeft}>
					{SHOW_LOGO && <img className={style.logo} src={token ? logoIcon : logoLoginIcon} alt="logo" />}
					{token && (
						<div className={style.list}>
							{teaRoute.map(item => {
								const cls = [style.item, active === item.path && style.active].join(' ')
								return (
									<div onClick={linkTo(item.path)} className={cls} key={item.path}>
										{item.title}
									</div>
								)
							})}
						</div>
					)}
				</div>
				{token && (
					<Dropdown
						placement="bottom"
						dropdownRender={() => (
							<div className={style.popover}>
								{/* <div className={style.popoverItem} onClick={goProfile}>
									个人信息
								</div> */}
								<div className={style.popoverItem} onClick={loginOut}>
									退出登录
								</div>
							</div>
						)}
					>
						<div className={style.contentRight}>
							<img className={style.avatar} src={URL_COMM + 'default_avatar.png'} alt="" />
							<p>{teaInfo?.tea?.teacher_name}</p>
							<div className={style.downOutlined}>
								<DownOutlined />
							</div>
						</div>
					</Dropdown>
				)}
			</div>
		</div>
	)
}
